module.exports = __webpack_public_path__ + "img/ahc.707b105e.jpg";